//#region Utils
import { errorFree } from "utils/validations";
import { EVENTS_CONSTANTS } from "config/constants";
//#endregion

const { EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

//#region Validators
const isValidFormStep1 = (step1, errors) => {
	const { adviser } = step1.part1;
	const { periodId, duration } = step1.part2;
	const newErrors = {
		part1: {
			adviser: !adviser.code,
		},
		part2: {
			periodId: !Boolean(periodId),
			duration: {
				onlyDay: {
					date: false,
					time: {
						start: false,
						end: false,
						inactivity:
							errors.step1.part2.duration.onlyDay.time.inactivity.map(
								() => ({
									time: {
										start: false,
										end: false,
										areInvalidTimes: false,
									},
								})
							),
						/*inactivity: [{
                            time: {
                                start: false,
                                end: false,
                                areInvalidTimes: false
                            }
                        }]*/
					},
					areInvalidTimes: false,
				},
				manyDays: {
					date: {
						start: false,
						end: false,
					},
					days: false,
					areInvalidDates: false,
					time: errors.step1.part2.duration.manyDays.time.map(
						({ dayId, inactivity }) => {
							return {
								dayId,
								start: false,
								end: false,
								areInvalidTimes: false,
								inactivity: inactivity.map(() => ({
									time: {
										start: false,
										end: false,
										areInvalidTimes: false,
									},
									date: false,
								})),
							};
						}
					),
					/*
                    [
                        { 
                            dayId: 0, 
                            start: false, 
                            end: false,
                            areInvalidTimes: false,
                            inactivity: [
                                {
                                    time: {
                                        start: false,
                                        end: false,
                                        areInvalidTimes: false
                                    },
                                    date: false
                                }
                            ]
                        }
                    ],
                    */
				},
			},
		},
	};
	if (periodId === EVENT_PERIOD_IDS.ONLY_DAY) {
		const { date, time } = duration.onlyDay;
		const errorTime = {
			start: time.start <= -1,
			end: time.end <= -1,
			inactivity: duration.onlyDay.time.inactivity.map(({ time }) => {
				const errorInactivityTime = {
					start: time.start <= -1,
					end: time.end <= -1,
				};
				return {
					time: {
						...errorInactivityTime,
						areInvalidTimes:
							!errorInactivityTime.start &&
							!errorInactivityTime.end &&
							time.start >= time.end,
					},
				};
			}),
		};
		newErrors.part2.duration.onlyDay = {
			date: date <= -1,
			time: errorTime,
			areInvalidTimes:
				!errorTime.start && !errorTime.end && time.start >= time.end,
		};
	} else if (periodId === EVENT_PERIOD_IDS.MANY_DAYS) {
		const { date, days, time } = duration.manyDays;
		const errorDate = {
			start: date.start <= -1,
			end: date.end <= -1,
		};
		newErrors.part2.duration.manyDays = {
			date: {
				start: date.start <= -1,
				end: date.end <= -1,
			},
			areInvalidDates:
				!errorDate.start && !errorDate.end && date.start >= date.end,
			days: days.length === 0,
			time: time.map(({ dayId, start, end, inactivity }) => {
				const errorTime = {
					start: start <= -1,
					end: end <= -1,
				};
				return {
					dayId,
					start: start <= -1,
					end: end <= -1,
					areInvalidTimes:
						!errorTime.start && !errorTime.end && start >= end,
					inactivity: inactivity.map(({ time, date }) => {
						const errorInactivityTime = {
							start: time.start <= -1,
							end: time.end <= -1,
						};
						return {
							time: {
								...errorInactivityTime,
								areInvalidTimes:
									!errorInactivityTime.start &&
									!errorInactivityTime.end &&
									time.start >= time.end,
							},
							date: date <= -1,
						};
					}),
				};
			}),
		};
	}
	const isValid = errorFree(newErrors);
	return {
		isValid,
		newErrors,
	};
};
const isValidFormStep2 = step2 => {
	const { locationId, place } = step2.part1;
	const {
		publicLoad: {
			students: { publicByCampusIds, modalityId },
		},
	} = step2.part2;
	const newErrors = {
		part1: {
			locationId: locationId === 0,
			place: {
				campus: false,
				environment: {
					inCampus: {
						envId: false,
						floor: false,
					},
					outCampus: {
						internalOrExternal: false,
						address: false,
					},
					any: false,
				},
			},
		},
		part2: {
			publicLoad: {
				students: {
					publicByCampusIds: publicByCampusIds.length === 0,
					modalityId: modalityId === 0,
				},
			},
		},
	};
	if (locationId === 2) {
		const { campus, environment } = place;
		newErrors.part1.place = {
			campus: campus.id === 0,
			environment: {
				envName: !environment.envName.trim(),
				floor: !environment.floor.trim(),
			},
		};
	}
	const isValid = errorFree(newErrors);
	return {
		isValid,
		newErrors,
	};
};
//#endregion

export default {
	isValidFormStep1,
	isValidFormStep2,
};
